import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationError } from '@angular/router';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

import { AuthService } from './services/auth/auth.service';
import { InternetService } from './services/internet/internet.service';

import { filter } from 'rxjs/operators';
import { CommonService } from './services/common/common.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'wealth-growth';
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  is_offline: boolean = false;

  constructor(
    private router: Router,
    private idle: Idle,
    private keepalive: Keepalive,
    private authService: AuthService,
    private internetService: InternetService,
    private commonService: CommonService,
    private location: Location,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        if (event.error.name === 'ChunkLoadError') {
          window.location.reload();
          // Or navigate to an error page or show a modal
        }
      }
    });

    this.location.onUrlChange((url: string) => {
      const current_url = this.router.url;
      if (current_url != url) {
        window.location.reload();
      }
    });

    this.internetService.isOnline.subscribe((status: boolean) => {
      this.is_offline = !status;
    });

    // sets an idle timeout of 7200 (2 Hours) seconds, for testing purposes.
    idle.setIdle(7200);
    // sets a timeout period of 10 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(10);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.authService.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.authService.getUserLoggedIn().subscribe((userLoggedIn) => {
      if (userLoggedIn) {
        idle.watch();
        this.timedOut = false;
      } else {
        idle.stop();
      }
    });

    this.reset();
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd) // Only capture NavigationEnd events
      )
      .subscribe((event: NavigationEnd) => {
        // Perform actions on route change
        let token = localStorage.getItem('token');
        if (token && token !== 'null') {

        } else {
          // this.authService.logout();
          // this.router.navigate(['/login']);
        }


        // You can also call any service method here to log the route or perform other actions



      });

  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}
